import "./Drivers.scss";
import { useEffect, useState, useMemo, useCallback, useRef } from "react";
import TransporterService from "../../services/TransporterService";
import { useLoader } from "../../contexts/LoaderContext";
import SearchBar from "../../components/SearchBar/SearchBar";
import TableComponent from "../../components/TableComponent/TableComponent";
import StatsBoxContainer from "../../components/StatsBoxContainer/StatsBoxContainer";
import { useLoading } from "../../contexts/LoadingContext";
import { showToast } from "../../components/Toaster";
import { SelectChangeEvent } from "@mui/material";
import { useAuth } from "../../contexts/AuthContext";
import DriverService from "../../services/DriverService";
import DriverForm from "../../components/Drivers/DriverForm";
import ConfirmDialog from "../../components/ConfirmDialog/ConfirmDialog";
import {
  Driver,
  DriverListResponse,
  DriverFilters,
} from "../../interfaces/driver.interface";

interface DriverStats {
  totalDrivers: number;
  totalTransporters: number;
  totalTrucks: number;
}

function Drivers() {
  // Context hooks (must be first)
  const { userProfile, isAuthLoading } = useAuth();
  const { showLoader, hideLoader } = useLoader();
  const { setLoading } = useLoading();
  const loader = useLoading();

  // State management
  // const [trips, setTrips] = useState<any[]>([]);
  const [drivers, setDrivers] = useState<Driver[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalElements, setTotalElements] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  // const [tripStats, setTripStats] = useState<TripHistoryStats | null>(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [dateRange, setDateRange] = useState<{
    startDate: number | null;
    endDate: number | null;
  }>({ startDate: null, endDate: null });
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const initialLoadDone = useRef(false);
  const [driverStats, setDriverStats] = useState<DriverStats | null>(null);

  // Refs
  const dateTimePickerStartRef = useRef<{ reset: () => void }>(null);
  const dateTimePickerEndRef = useRef<{ reset: () => void }>(null);
  const debounceTimeout = useRef<NodeJS.Timeout | null>(null);
  const statsDebounceTimeout = useRef<NodeJS.Timeout | null>(null);
  const abortControllerRef = useRef<AbortController | null>(null);

  const [error, setError] = useState<string | null>(null);

  // const [federationData, setFederationData] = useState<FederationTransporter[]>(
  //   []
  // );
  const [driverData, setDriverData] = useState<Driver[]>([]);
  const [searchSuggestions, setSearchSuggestions] = useState<string[]>([]);
  const [dataLoaded, setDataLoaded] = useState(false);
  const isLoading = useRef(false);

  const [driverNewStats, setDriverNewStats] = useState<DriverStats>({
    totalDrivers: 0,
    totalTransporters: 0,
    totalTrucks: 0,
  });

  const [showDriverForm, setShowDriverForm] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [driverFormReadOnly, setDriverFormReadOnly] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [driverToDelete, setDriverToDelete] = useState<Driver | null>(null);

  // const fetchDriverData = useCallback(
  //   async (page: number, suppressLoader?: boolean, forceRefresh?: boolean) => {
  //     // Prevent multiple simultaneous calls
  //     if (isLoading.current) {
  //       console.log("Fetch already in progress, skipping");
  //       return;
  //     }

  //     isLoading.current = true;

  //     try {
  //       if (!initialLoadDone.current) {
  //         setDataLoaded(false);
  //       }

  //       if (!suppressLoader) {
  //         showLoader();
  //       } else {
  //         loader.setLoading(true);
  //       }

  //       setError(null);
  //       console.log("userProfile", userProfile);
  //       const response: DriverListResponse = await DriverService.getDrivers(
  //         userProfile,
  //         { limit: pageSize, skip: (page - 1) * pageSize }
  //       );

  //       //  const response: FederationResponse =
  //       // await TransporterService.getFederationTransporters();

  //       if (!response?.error && Array.isArray(response?.data.content)) {
  //         // setFederationData(response.data);
  //         setDriverData(response.data.content);

  //         // Calculate stats with null checks
  //         const totalDrivers = response.data.content.reduce(
  //           (sum, transporter) => {
  //             return 0;
  //             // sum +
  //             // (transporter.drivers && Array.isArray(transporter.drivers)
  //             //   ? transporter.drivers.length
  //             //   : 0)
  //           },
  //           0
  //         );
  //         const totalTransporters = 0;
  //         //  response.data.length ;
  //         const totalTrucks = response.data.content.reduce(
  //           (sum, transporter) => {
  //             return 0;
  //             // sum +
  //             // (transporter.trucks && Array.isArray(transporter.trucks)
  //             //   ? transporter.trucks.length
  //             //   : 0)
  //           },
  //           0
  //         );

  //         const stats: DriverStats = {
  //           totalDrivers,
  //           totalTransporters,
  //           totalTrucks,
  //         };
  //         setDriverStats(stats);
  //       } else {
  //         console.error(
  //           "Error in fetching federation data:",
  //           response?.message || "Invalid response format"
  //         );
  //         setError(response?.message || "Error fetching federation data");
  //         // setFederationData([]);
  //         setDriverData([]);
  //       }
  //     } catch (err: any) {
  //       console.error("Error fetching data:", err);
  //       setError(err.message || "An error occurred while fetching data");
  //     } finally {
  //       setDataLoaded(true);
  //       initialLoadDone.current = true;
  //       isLoading.current = false;

  //       setTimeout(() => {
  //         if (!suppressLoader) {
  //           hideLoader();
  //         } else {
  //           loader.setLoading(false);
  //         }
  //       }, 1000);
  //     }
  //   },
  //   [showLoader, hideLoader, loader]
  // );

  // Table actions: View, Edit, Delete
  const handleViewDriver = (row: any) => {
    setSelectedDriver(row);
    setDriverFormReadOnly(true);
    setShowDriverForm(true);
  };

  const handleEditDriver = (row: any) => {
    setSelectedDriver(row);
    setDriverFormReadOnly(false);
    setShowDriverForm(true);
  };

  const handleDeleteDriver = (row: Record<string, any>) => {
    // Map row to Driver shape for dialog display and deletion
    setDriverToDelete({
      id: row.id,
      driverName: row.driverName,
      driverLicenseNumber: row.driverLicenseNumber,
      driverMobileNumber: row.driverMobileNumber,
      driverEmail: row.driverEmail,
      dateOfBirth: row.dateOfBirth,
      driverAddress: row.driverAddress,
      driverStatus: row.driverStatus,
      transporterId: row.transporterId,
      transporterName: row.transporterName,
      transporterUniqueId: row.transporterUniqueId,
      truckId: row.truckId,
      truckName: row.truckName,
      available: row.available,
      createdAt: row.createdAt,
      updatedAt: row.updatedAt,
      createdBy: row.createdBy,
      updatedBy: row.updatedBy,
      links: row.links,
      transporterIdName: row.transporterIdName,
      currentTruckIdName: row.currentTruckIdName,
    });
    setDeleteDialogOpen(true);
  };

  const confirmDeleteDriver = async () => {
    if (!driverToDelete) return;
    try {
      showLoader();
      await DriverService.deleteDriverRBAC(userProfile,driverToDelete.id!);
      showToast("Driver deleted successfully", "success");
      setDeleteDialogOpen(false);
      setDriverToDelete(null);
      loadDrivers(currentPage, true);
    } catch (error) {
      showToast("Failed to delete driver", "error");
    } finally {
      hideLoader();
    }
  };

  const tableActions = useMemo(
    () => [
      {
        label: "View",
        callback: handleViewDriver,
        isEnabled: () => true,
      },
      {
        label: "Edit",
        callback: handleEditDriver,
        isEnabled: () => true,
      },
      {
        label: "Delete",
        callback: handleDeleteDriver,
        isEnabled: () => true,
      },
    ],
    [drivers, userProfile, currentPage]
  );

  const statsData = useMemo(
    () => [
      {
        name: "Total Drivers",
        value: driverStats?.totalDrivers || 0,
        valueColor: "#59585B",
      },
      {
        name: "Transporters",
        value: driverStats?.totalTransporters || 0,
        valueColor: "#10B981",
      },
      {
        name: "Total Trucks",
        value: driverStats?.totalTrucks || 0,
        valueColor: "#FF9F1C",
      },
    ],
    [driverStats]
  );
  // Load trips data
  const loadDrivers = useCallback(
    async (page: number, suppressLoader = false) => {
      // Cancel any pending request
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }

      // Create new AbortController for this request
      abortControllerRef.current = new AbortController();

      if (!initialLoadDone.current) {
        showLoader();
      } else if (!suppressLoader) {
        setLoading(true);
      }

      try {
        const response = await DriverService.getDriversRBAC(userProfile, {
          limit: pageSize,
          skip: (page - 1) * pageSize,
          search: searchQuery.trim() || undefined,
          // transporterIds:  undefined,
          signal: abortControllerRef.current.signal,
        });

        // If the request was aborted, don't process the response
        if (abortControllerRef.current.signal.aborted) {
          return;
        }

        if (!response?.data?.data?.content) {
          setDrivers([]);
          setTotalPages(1);
          setTotalElements(0);
          return;
        }

        const newDrivers = response.data.data.content;
        setDrivers(newDrivers);
        setTotalPages(response.data.data.page?.totalPages || 1);
        setTotalElements(response.data.data.page?.totalElements || 0);

        // Load stats on initial load or when there's a search query
        if (!initialLoadDone.current || searchQuery) {
          try {
            const statsResponse = await DriverService.getDriversStats({
              signal: abortControllerRef.current.signal,
            });
            if (!abortControllerRef.current.signal.aborted) {
              setDriverStats(statsResponse.data);
            }
          } catch (error: any) {
            if (!error.name || error.name !== "AbortError") {
              setDriverStats(null);
              console.error("Error loading Truck stats", error);
            }
          }
        }
      } catch (error: any) {
        // Only handle non-abort errors
        if (!error.name || error.name !== "AbortError") {
          console.error("Error loading trips", error);
          // Don't clear data on error, just log it
        }
      } finally {
        if (!initialLoadDone.current) {
          setTimeout(() => {
            hideLoader();
            setIsInitialLoading(false);
            initialLoadDone.current = true;
          }, 1000);
        } else if (!suppressLoader) {
          setLoading(false);
        }
      }
    },
    [
      userProfile,
      pageSize,
      searchQuery,
      dateRange,
      showLoader,
      hideLoader,
      setLoading,
    ]
  );

  // Load trips when dependencies change
  useEffect(() => {
    if (!isAuthLoading && userProfile) {
      console.log("[Drivers] Calling loadDrivers, userProfile:", userProfile);
      loadDrivers(currentPage);
    } else if (!isAuthLoading && !userProfile) {
      console.log(
        "[Drivers] Skipping loadDrivers: userProfile is null after auth loading"
      );
    }
  }, [isAuthLoading, userProfile, currentPage, loadDrivers]);

  // Cleanup function to abort any pending requests when component unmounts
  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  const handleSearch = useCallback((query: string) => {
    if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
    debounceTimeout.current = setTimeout(() => {
      setSearchQuery(query);
      setCurrentPage(1);
    }, 500);
  }, []);

  const handlePageChange = useCallback(
    (page: number) => {
      // Cancel any pending request before changing page
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }

      if (page >= 1 && page <= totalPages) {
        setCurrentPage(page);
      }
    },
    [totalPages]
  );

  const handlePageSizeChange = useCallback(
    (event: SelectChangeEvent<number>) => {
      // Cancel any pending request before changing page size
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }

      setPageSize(Number(event.target.value));
      setCurrentPage(1);
    },
    []
  );

  const handleRefresh = useCallback(async () => {
    // Cancel any pending request before refresh
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    try {
      setLoading(true);
      await loadDrivers(currentPage, true);
    } catch (error) {
      console.error("Error refreshing data:", error);
    } finally {
      setLoading(false);
    }
  }, [loadDrivers, currentPage, setLoading]);

  // Memoized table data with null checks
  const tableData = useMemo(
    () =>
      drivers?.map((driver) => ({
        id: driver.id,
        driverName: driver.driverName || "N/A",
        driverMobileNumber: driver.driverMobileNumber || "N/A",
        driverLicenseNumber: driver.driverLicenseNumber || "N/A",
        dateOfBirth: driver.dateOfBirth || "N/A",
        driverEmail: driver.driverEmail || "N/A",
        driverStatus: driver.driverStatus || "N/A",
        driverAddress: driver.driverAddress || "N/A",
        transporterName: driver.transporterIdName?.name || "",
        transporterUniqueId: driver.transporterIdName?.uniqueId || "",
        truckName: driver.currentTruckIdName?.name || "N/A",
        truckId: driver.currentTruckIdName?.id || "N/A",
        available: driver.available || "N/A",
        transporterIdName: driver.transporterIdName || "N/A",
        currentTruckIdName: driver.currentTruckIdName || "N/A",
      })) || [],
    [drivers]
  );

  // Memoize columns definition
  const columns = useMemo(
    () => [
      {
        header: "Driver Name",
        accessor: "driverName",
        sortable: true,
        centerAlign: true,
        width: "100px",
        cell: (value: string) => value || "N/A",
      },
      {
        header: "Mobile",
        accessor: "driverMobileNumber",
        width: "130px",
        minWidth: "130px",
        cell: (value: string) => value || "N/A",
      },
      {
        header: "Transporter Name",
        accessor: "transporterName",
        sortable: true,
        centerAlign: true,
        width: "150px",
        minWidth: "150px",
      },
      {
        header: "Transporter UniqueId",
        accessor: "transporterUniqueId",
        sortable: true,
        centerAlign: true,
        width: "150px",
        minWidth: "150px",
      },
      {
        header: "Truck Name",
        accessor: "truckName",
        sortable: true,
        centerAlign: true,
        width: "120px",
        minWidth: "120px",
      },
      {
        header: "Truck Id",
        accessor: "truckId",
        sortable: true,
        centerAlign: true,
        width: "100px",
        minWidth: "100px",
      },
      {
        header: "Status",
        accessor: "driverStatus",
        sortable: true,
        centerAlign: true,
        width: "120px",
        cell: (value: string) => {
          return (
            <span
              className={`px-2 py-1 rounded-full text-sm w-[100px] inline-block ${
                value === "Available"
                  ? "bg-green-100 text-green-800"
                  : "bg-orange-100 text-orange-500"
              }`}
            >
              {value}
            </span>
          );
        },
      },
    ],
    []
  );

  // const tableData = useMemo(() => {
  //   if (!driverData || !Array.isArray(driverData)) return [];

  //   const driverRows: FedDriverTableRow[] = [];

  //   driverData.forEach((driver) => {
  //     if (driver && driver.id) {
  //       driverRows.push({
  //         id: driver.id,
  //         driverName: driver.driverName,
  //         driverMobileNumber: driver.driverMobileNumber,
  //         driverLicenseNumber: driver.driverLicenseNumber,
  //         dateOfBirth: driver.dateOfBirth,
  //         driverEmail: driver.driverEmail,
  //         driverStatus: driver.driverStatus,
  //         transporterName: driver.transporterIdName?.name || "",
  //         transporterUniqueId: driver.transporterIdName?.uniqueId || "",
  //         truckName: driver.currentTruckIdName?.name || "",
  //         truckId: driver.currentTruckIdName?.id || "",
  //         available: driver.available,
  //         transporterIdName: driver.transporterIdName,
  //         currentTruckIdName: driver.currentTruckIdName,
  //       });
  //     }
  //   });

  //   return driverRows.sort((a, b) => a.driverName.localeCompare(b.driverName));
  // }, [driverData]);

  // Memoize filtered and paginated data
  const filteredAndPaginatedData = useMemo(() => {
    let filteredData = tableData;

    // Apply search filter
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      filteredData = filteredData.filter(
        (row) => row.driverName.toLowerCase().includes(query)
        // ||
        //   row.transporter.toLowerCase().includes(query) ||
        //   row.federation.toLowerCase().includes(query)
      );
    }

    // Calculate pagination
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;

    return {
      data: filteredData.slice(startIndex, endIndex),
      totalElements: filteredData.length,
      totalPages: Math.ceil(filteredData.length / pageSize),
    };
  }, [tableData, searchQuery, currentPage, pageSize]);

  // Memoize search suggestions
  const searchSuggestionsMemo = useMemo(() => {
    if (tableData.length > 0) {
      const suggestions = new Set<string>();

      tableData.forEach((row) => {
        if (row.driverName) suggestions.add(row.driverName);
        // if (row.transporter) suggestions.add(row.transporter);
        // if (row.federation) suggestions.add(row.federation);
      });

      return Array.from(suggestions);
    }
    return [];
  }, [tableData]);

  // Memoize stats data
  // const statsData = useMemo(() => {
  //   // Use filtered data if search is active, otherwise use all data
  //   const dataToUse = searchQuery ? filteredAndPaginatedData.data : tableData;

  //   const totalDrivers = dataToUse.length;
  //   const totalTransporters = searchQuery
  //     ? new Set(dataToUse.map((d) => d.transporterIdName)).size
  //     : driverStats.totalTransporters;
  //   const totalTrucks = searchQuery
  //     ? new Set(dataToUse.map((d) => d.transporterIdName)).size * 10 // Estimate for filtered view
  //     : driverStats.totalTrucks;

  //   return [
  //     {
  //       name: "Total Drivers",
  //       value: totalDrivers,
  //       valueColor: "#59585B",
  //     },
  //     {
  //       name: "Transporters",
  //       value: totalTransporters,
  //       valueColor: "#10B981",
  //     },
  //     {
  //       name: "Total Trucks",
  //       value: totalTrucks,
  //       valueColor: "#FF9F1C",
  //     },
  //   ];
  // }, [searchQuery, filteredAndPaginatedData.data, tableData, driverStats]);

  // Handle page size change
  // const handlePageSizeChange = useCallback(
  //   (event: SelectChangeEvent<number>) => {
  //     setPageSize(Number(event.target.value));
  //     setCurrentPage(1); // Reset to first page when changing page size
  //   },
  //   []
  // );

  // // Memoize table actions
  // const tableActions = useMemo(
  //   () => [
  //     {
  //       label: "View Details",
  //       callback: (row: Record<string, any>) => {
  //         // Find the original driver data
  //         const driver = tableData.find((d) => d.id === row.id);
  //         if (driver) {
  //           // For now, just show a toast with driver info
  //           showToast(
  //             `Driver: ${driver.driverName} | Transporter: ${driver.transporterIdName.name}`,
  //             "info"
  //           );
  //         }
  //       },
  //       isEnabled: (row: Record<string, any>) => true,
  //     },
  //   ],
  //   [tableData]
  // );

  // // Initial data fetch
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       await fetchDriverData(currentPage, false);
  //     } catch (error) {
  //       console.error("Error in initial fetch:", error);
  //     }
  //   };

  //   fetchData();

  //   return () => {
  //     // Cleanup function
  //   };
  // }, [fetchDriverData]);

  // // Update search suggestions when table data changes
  // useEffect(() => {
  //   setSearchSuggestions(searchSuggestionsMemo);
  // }, [searchSuggestionsMemo]);

  // // Handle manual refresh
  // const handleManualRefresh = useCallback(() => {
  //   fetchDriverData(currentPage, true, true);
  // }, [fetchDriverData]);

  // // Handle search input changes
  // const handleSearchChange = useCallback((query: string) => {
  //   setSearchQuery(query);
  //   setCurrentPage(1); // Reset to first page on search
  // }, []);

  // // Handle page change
  // // const handlePageChange = useCallback((page: number) => {
  // //   setCurrentPage(page);
  // // }, []);

  //     // Guard: Wait for userProfile to be available before rendering
  // if (!userProfile && isAuthLoading) {
  //   return (
  //     <div className="drivers-error flex flex-col items-center justify-center min-h-[300px]">
  //       <div className="text-lg font-semibold text-gray-700 mb-2">Loading user profile...</div>
  //       <div className="text-gray-500">Please wait while we load your profile information.</div>
  //     </div>
  //   );
  // }

  // --- DEBUG LOGS ---
  if (isAuthLoading) {
    console.log("[Drivers] Auth is loading, waiting for userProfile...");
  } else if (!userProfile) {
    console.log("[Drivers] userProfile is null after auth loading!");
  } else {
    console.log("[Drivers] userProfile loaded:", userProfile);
  }

  // if (isAuthLoading) {
  //   // setLoading(true);
  //   // showLoader();
  //   // or <FullPageLoader /> or your loading UI
  //   return (
  //     <div className="drivers-error flex flex-col items-center justify-center min-h-[300px]">
  //       <div className="text-lg font-semibold text-gray-700 mb-2">
  //         Loading user profile...
  //       </div>
  //       <div className="text-gray-500">
  //         Please wait while we load your profile information.
  //       </div>
  //     </div>
  //   );
  // }

  // if (!userProfile) {
  //   return (
  //     <div className="drivers-error flex flex-col items-center justify-center min-h-[300px]">
  //       <div className="text-lg font-semibold text-gray-700 mb-2">
  //         Not authenticated
  //       </div>
  //       <div className="text-gray-500">Please login to access this page.</div>
  //     </div>
  //   );
  // }

  return (
    <div className="drivers-page p-[20px]">
      <StatsBoxContainer stats={statsData} />

      <div className="flex justify-between items-center py-[30px]">
        <SearchBar
          placeholder="Search drivers, transporters, or federations..."
          onSearch={handleSearch}
          showClearButton={true}
          suggestions={searchSuggestions}
          onSuggestionClick={(suggestion) => {
            setSearchQuery(suggestion);
            setCurrentPage(1); // Reset to first page on suggestion click
          }}
        />
        <div className="flex items-center space-x-2">
          <div className="flex items-center space-x-2">
            <button
              type="button"
              className="primary_button"
              onClick={() => {
                setSelectedDriver(null);
                setShowDriverForm(true);
              }}
            >
              Add Driver
            </button>
            <button
              type="button"
              className={`secondary_button ${
                loader.isLoading ? "opacity-70" : ""
              }`}
              onClick={handleRefresh}
              disabled={loader.isLoading}
            >
              <div className="flex items-center">
                {loader.isLoading ? (
                  <>
                    <svg
                      className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Refreshing...
                  </>
                ) : (
                  "Refresh"
                )}
              </div>
            </button>
          </div>
        </div>
      </div>

      {isInitialLoading ? (
        <div className="center_floater_container max-h-[231px] text-[20px]">
          {/* Loading... */}
        </div>
      ) : drivers?.length > 0 || totalElements > 0 ? (
        <div>
          <TableComponent
            columns={columns}
            data={tableData}
            showCheckboxes={false}
            showSerialNumbers={true}
            searchQuery={searchQuery}
            className="trip-history-table"
            showPagination={true}
            pageSize={pageSize}
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
            highlightSearchMatches={false}
            enableClientSideFiltering={false}
            totalElements={totalElements}
            isServerSidePagination={true}
            actions={tableActions}
          />
        </div>
      ) : (
        <div className="center_floater_container max-h-[231px] text-[20px]">
          No results !
        </div>
      )}

      {/* {isInitialLoading ? (
        <div className="flex justify-center items-center">
          <p className="text-gray-500">No drivers found</p>
        </div>
      ) : (
        <div className="table">
          <TableComponent
            showPagination={true}
            columns={columns}
            data={tableData}
            searchQuery={searchQuery}
            showCheckboxes={false}
            uniqueAccessor="id"
            currentPage={currentPage}
            pageSize={pageSize}
            totalPages={Math.ceil(tableData.length / pageSize)}
            totalElements={tableData.length}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
            enableClientSideFiltering={true}
            actions={tableActions}
          />
        </div>
      )} */}

      {/* DriverForm modal */}
      {showDriverForm && (
        <DriverForm
          isOpen={showDriverForm}
          onClose={() => setShowDriverForm(false)}
          driver={selectedDriver}
          onSuccess={() => {
            setShowDriverForm(false);
            loadDrivers(currentPage, true);
          }}
        />
      )}

      {error && (
        <div className="flex justify-center items-center mt-4">
          <p className="text-red-500">Error: {error}</p>
        </div>
      )}

      <ConfirmDialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        onConfirm={confirmDeleteDriver}
        title="Delete Driver"
        message={`Are you sure you want to delete driver ${driverToDelete?.driverName}? This action cannot be undone.`}
        confirmText="Delete"
        cancelText="Cancel"
        confirmColor="error"
      />
    </div>
  );
}

export default Drivers;
